import {
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Badge,
  Avatar,
  Button,
} from "@chakra-ui/react";
import { ProfileIcon } from "../Icons/Icons";
import {
  FaUser,
  FaCog,
  FaSignOutAlt,
  FaGlobe,
  FaUserAlt,
} from "react-icons/fa"; // Import FaGlobe pour l'icône de langue
import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useNavbar } from "../../context/NavbarContext";
import { useTranslation } from "react-i18next";
// import svg image from assets
import svgCreditIcon from "../../assets/svg/credits.svg";
import "../../i18n";
import bmLogo from "../../assets/svg/bm_logo.svg";
import NotificationCenter from "./NotificationCenter";

export default function HeaderLinks(props) {


const { currentUser, logout, changeLanguage } = useAuth();
  const { credits } = useNavbar();
  const { t, i18n } = useTranslation();

  const handleChangeLanguage = async (lng) => {
    try {
      await changeLanguage(lng);
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  const languages = [
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "it", name: "Italiano", flag: "🇮🇹" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "jp", name: "日本人", flag: "🇯🇵" },
  ];

  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      m={{sm: "25px", md: "0px"}}
      alignItems="center"
      justifyContent="center"
      flexDirection="row"
      gap="20px"
    >
      <NotificationCenter />
      <Menu>
        <MenuButton
          as={IconButton}
          icon={<FaGlobe />}
          aria-label={t('selectLanguage')}
        />
        <MenuList
          border="transparent"
          backdropFilter="blur(63px)"
          bg="linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.69) 76.65%)"
          borderRadius="20px"
        >
          {languages.map(({ code, name, flag }) => (
            <MenuItem
              bg="transparent"
              borderRadius="8px"
              _hover={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              mb="10px"
              key={code}
              onClick={() => handleChangeLanguage(code)}
            >
              <Badge mr={2}>{flag}</Badge>
              <Text>{name}</Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Menu>
        <MenuButton
          as={Button}
          rounded="full"
          variant="link"
          cursor="pointer"
          minW={0}
        >
          <Avatar
            size="sm"
            src={currentUser?.photoURL}
            name={currentUser?.displayName || currentUser?.email}
        />
        </MenuButton>
        <MenuList
          border="transparent"
          backdropFilter="blur(63px)"
          bg="linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.69) 76.65%)"
          borderRadius="20px"
        >
          <Flex
            flexDirection="column"
            px={4}
            py={2}
            bg="transparent"
            borderRadius="8px"
          >
            <img
              src={svgCreditIcon}
              alt={t('credits1')}
              width="35px"
              style={{ position: "absolute" }}
            />{" "}
            <Text
              style={{ paddingTop: "5px", paddingLeft: "45px" }}
              fontWeight="bold"
              bg="transparent"
              color="teal.200"
            >
              {credits}
            </Text>
          </Flex>
          <Flex flexDirection="column" mt="10px">
            <NavLink to="/account">
              <MenuItem
                bg="transparent"
                borderRadius="8px"
                _hover={{
                  bg: "whiteAlpha.200",
                }}
                _active={{
                  bg: "whiteAlpha.300",
                }}
                _focus={{
                  bg: "transparent",
                }}
                mb="10px"
              >
                <Flex align="center">
                  <FaUser size="20px" style={{ marginRight: "12px" }} />
                  <Text>{t("my_account")}</Text>
                </Flex>
              </MenuItem>
            </NavLink>
            <NavLink to="/subscribe">
              <MenuItem
                bg="transparent"
                borderRadius="8px"
                _hover={{ bg: "whiteAlpha.200" }}
                _active={{ bg: "whiteAlpha.300" }}
                _focus={{ bg: "transparent" }}
                mb="10px"
              >
                <Flex align="center">
                  <FaCog size="20px" style={{ marginRight: "12px" }} />
                  <Text>{t("manage_subscription")}</Text>
                </Flex>
              </MenuItem>
            </NavLink>
            <MenuItem
              borderRadius="8px"
              bg="transparent"
              _hover={{ bg: "whiteAlpha.200" }}
              _active={{ bg: "whiteAlpha.300" }}
              _focus={{ bg: "transparent" }}
              onClick={logout}
            >
              <Flex align="center">
                <FaSignOutAlt size="20px" style={{ marginRight: "12px" }} />
                <Text>{t("logout")}</Text>
              </Flex>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}
